import type { App } from 'vue'

import SmartButtonGroup from './smart-button-group/index.vue'
import SmartButtonList from './smart-button-list/index.vue'
import SmartButtonText from './smart-button-text/index.vue'
import SmartButton from './smart-button/index.vue'
import SmartCrud from './smart-crud/index.vue'
import SmartDetail from './smart-detail/index.vue'
import SmartEchart from './smart-echart/index.vue'
import SmartForm from './smart-form/index.vue'
import SmartHeader from './smart-header/index.vue'
import SmartIconPicker from './smart-icon-picker/index.vue'
import SmartIcon from './smart-icon/index.vue'
import SmartInput from './smart-input/index.vue'
import SmartInputTag from './smart-input-tag/index.vue'
import SmartModalDetail from './smart-modal-detail/index.vue'
import SmartModalForm from './smart-modal-form/index.vue'
import SmartModal from './smart-modal/index.vue'
import SmartPassword from './smart-password/index.vue'
import SmartProvider from './smart-provider/index.vue'
import SmartRadioButton from './smart-radio-button/index.vue'
import SmartRangePicker from './smart-range-picker/index.vue'
import SmartRipple from './smart-ripple/index.vue'
import SmartSearch from './smart-search/index.vue'
import SmartSelect from './smart-select/index.vue'
import SmartTable from './smart-table/index.vue'
import SmartUpload from './smart-upload/index.vue'

import UnitSelect from './jt-unit-select/index.vue'


const install = (app: App) => {
  app.component('UnitSelect', UnitSelect)
  app.component('SmartButtonGroup', SmartButtonGroup)
  app.component('SmartButtonList', SmartButtonList)
  app.component('SmartButtonText', SmartButtonText)
  app.component('SmartButton', SmartButton)
  app.component('SmartCrud', SmartCrud)
  app.component('SmartDetail', SmartDetail)
  app.component('SmartEchart', SmartEchart)
  app.component('SmartForm', SmartForm)
  app.component('SmartHeader', SmartHeader)
  app.component('SmartIconPicker', SmartIconPicker)
  app.component('SmartIcon', SmartIcon)
  app.component('SmartInput', SmartInput)
  app.component('SmartInputTag', SmartInputTag)
  app.component('SmartModalDetail', SmartModalDetail)
  app.component('SmartModalForm', SmartModalForm)
  app.component('SmartModal', SmartModal)
  app.component('SmartPassword', SmartPassword)
  app.component('SmartProvider', SmartProvider)
  app.component('SmartRadioButton', SmartRadioButton)
  app.component('SmartRangePicker', SmartRangePicker)
  app.component('SmartRipple', SmartRipple)
  app.component('SmartSearch', SmartSearch)
  app.component('SmartSelect', SmartSelect)
  app.component('SmartTable', SmartTable)
  app.component('SmartUpload', SmartUpload)
}
export default {
  install
}
